import { AgentEmailSignatureInsertOn, TUserPreference, getEpochInSeconds } from '@cloud-wave/neon-common-lib/common';

export default {
  userId: '',
  tenantId: '',
  emailSignature: '',
  emailSignatureInsetOn: AgentEmailSignatureInsertOn.NEVER,
  createdAt: Date.now(),
  updatedAt: Date.now(),
  callbackNumber: null,
  e911UpdatedTimestamp: getEpochInSeconds(),
  location: null,
  centralisedLogging: false,
} satisfies TUserPreference;
